import { useEffect, useState } from 'react';

// Default breakpoint for mobile screens
const useIsMobile = (breakPoint = 576) => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= breakPoint : false
    );

    useEffect(() => {
        const handleScreenSize = () => {
            setIsMobile(window.innerWidth <= breakPoint);
        };

        // Add the resize event listener
        window.addEventListener('resize', handleScreenSize);

        // Initial check
        handleScreenSize();

        // Cleanup function
        return () => {
            window.removeEventListener('resize', handleScreenSize);
        };
    }, [breakPoint]); // Re-run if `breakPoint` changes

    return isMobile;
};

export default useIsMobile;
